// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___5a28","questions":"styles_questions__2pVKd","footer":"styles_footer__2VeP5"};